import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin: ${({ theme }) => theme.spacing.km6} auto;
  width: 100%;
  max-width: 378px;
  text-align: center;
`;

export const Img = styled.img``;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.color.text.neutral.strong};
    font-size: ${theme.font.size.m6};
    font-weight: ${theme.font.weight.bold};
    line-height: ${theme.font.lineHeight.tiny};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.color.text.neutral.default};
    font-size: ${theme.font.size.m5};
    font-weight: ${theme.font.weight.medium};
    line-height: ${theme.font.lineHeight.medium};
    margin-top: ${theme.spacing.km2};
  `}
`;

export const WrapperActions = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km4};
`;
